module.exports = __webpack_public_path__ + "img/bingo_ball-77.21ab4b70.png";